import { render, staticRenderFns } from "./JdmPage.vue?vue&type=template&id=37f91467&scoped=true"
import script from "./JdmPage.vue?vue&type=script&lang=js"
export * from "./JdmPage.vue?vue&type=script&lang=js"
import style0 from "./JdmPage.vue?vue&type=style&index=0&id=37f91467&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37f91467",
  null
  
)

export default component.exports